/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import Main from '../../../components/HOC/Main'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/common/Button';
import { selectSelectedBlogs, setSelectedBlogs, toggleCommonDeleteModal } from '../../../store/slices/common';
import CustomTable from '../../../components/common/CustomTable';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { clearBlogsData, deleteBlog, fetchBlogs, selectBlogsData, setBlogsData } from '../../../store/slices/api/inner/blogsSlice';
import TableAction from '../../../components/TableAction';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { NAVIGATION } from '../../../lib/navigation';

export default function BlogsPage() {
  const dispatch = useDispatch();
  const blogsData = useSelector(selectBlogsData);
  const selectedBlogs = useSelector(selectSelectedBlogs);
  const navigate = useNavigate();

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchBlogs,
    setValueAction: setBlogsData,
    clearValueActionOnError: clearBlogsData,
    isForm: false,
    successMessage: false,
  });

    // delete start
    const openDeleteModal = (data) => {
      dispatch(setSelectedBlogs({
        blog_id: data?.blog_id
      }))
      dispatch(toggleCommonDeleteModal())
      
    }
    const cancelDeleteModal = () => {
      dispatch(setSelectedBlogs(null))
      dispatch(toggleCommonDeleteModal())
    }

    const afterAPICall = (res) => {
      fetchData()
      dispatch(setSelectedBlogs(null))
      dispatch(toggleCommonDeleteModal())
    }
    
    const { handleSubmit: handleDelete } = useApiRequest({
      apiAction: deleteBlog,
      isForm: false,
      afterAPICall,
    });
    // delete end 

    const handleEdit = (data) => {
      navigate(NAVIGATION.INNER_NAVIGATION.BLOGS.UPDATE_BLOG, { state: { blogData: data } });
    };

  const handleAdd = () => {
    dispatch(setSelectedBlogs(null));
    navigate(NAVIGATION.INNER_NAVIGATION.BLOGS.ADD_BLOG)
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'title',
      filterFn: 'equalsString',
    },
    {
      accessorKey: 'short_description',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'category',
      cell: info => info.getValue()?.blog_category_name,
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'thumbnail',
      cell: info => <img src={`${process.env.REACT_APP_BASE_URL}/assets/${info.getValue()}`} className='rounded' style={{height:"80px"}} alt='thumbnail' />,
      filterFn: 'includesStringSensitive',
    },

    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData() ;
  }, [])

  return (
    <Main crumbs={[{ title: "blog" }, { title: "blogs" }]} handleDelete={() => {handleDelete({ blogId: selectedBlogs.blog_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={blogsData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Blog</Button>} />
    </Main>
  )
}
